import {MAP_MIN_ZOOM_LEVEL, DEFAULT_MAP_POSITION} from '../constants';

// persisted states in localStorage

const storage = {
  mapGeoJson: null
};

const map = {
  zoomLevel: MAP_MIN_ZOOM_LEVEL,
  position: DEFAULT_MAP_POSITION
};

const user = {
  oauthToken: '',
  oauthTokenSecret: '',
  profileId: '',
  firstName: '',
  lastName: '',
  organizations: [],
  email: '',
  avatar: null,
  userDataFetchedAt: 0,
};

const userAccommodationInfo = {
  qualifiedSpots: 0,
  heldSpot: null,
  reservedSpots: [],
  attendee: {},
};

const mapAccommodationInfo = {
  clubName: null,
  dtmClose: 0, // In Milisec
  dtmOpen: 0, // In Milisec
  eventName: null,
  isOpen: null
};

const checkout = {
  spotToReserve: null,
  spotToUnreserve: null,
  requestId: null,
  event: null,
  isLoading: false,
  timeStamp: 0, // In Milisec
  isBackendRelasedSpot: null,
};

const search = {
  query: '',
  result: [],
  filterOptions: {sizes: {}, surface: {} },
  appliedFilters: {sizes: [], surface: [] },
  availableFilteredSpots: [],
  allFilteredSpots: [],
  isFilterApplied: false,
  isLoading: false
};

const parkingSpots = {
  selectedSpot: null,
  selectedPointsOfInterest: null,
  showParkingAreaMarker: true,
  showParkingSpotMarker: true,
  showParkingSpotMarkerLabel: true,
  list: {},
  parkingDataFetchedAt: 0,
  groupedParkingSpots: {},
};

//Session only stores

const pusher = {
  socketId: null
};

const navOptions = {
  isDrawerOpened: false,
  isNavHelpOpened: false,
  isSearchFormOpened: false,
  isFindPeopleFormOpened: false,
  isCheckoutPageOpened: false,
  spotInfoDetailedView: false
};

const geoJsonData = {
  parkingLocations: [],
  parkingSpots: [],
  pointsOfInterest: [],
};

const session = {
  toasters: [],
  blockedSpotsList: [],
  parkingSpotFeaturesList: {},
  areaSpotsMapList: {},
  preBookedSpotsList: [],
  isBookingOpen: false,
  eventType: '',
  openTime: null,
  closeTime: null,
};

// All States

export const defaultState = {
  user,
  map,
  storage,
  parkingSpots,
  userAccommodationInfo,
  mapAccommodationInfo,
  checkout,
  search,
  geoJsonData,
  pusher,
  navOptions,
  session
};



// WEBPACK FOOTER //
// ./src/reducers/defaultState.js